import { make } from 'vuex-pathify'
import dottie from 'dottie'
import axios from 'axios'

export const apiPrivate = axios.create({
  baseURL: '/api/private',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const state = {
  email: null,
  nickname: null,
  urlAlias: null,
  userId: null,
  avatar: null,
  sessionUserId: null,
  isAuthenticated: false
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  read(state, { email, nickname, urlAlias, userId, avatar, purchases }) {
    state.email = email
    state.nickname = nickname
    state.urlAlias = urlAlias
    state.userId = userId
    state.avatar = avatar
    state.sessionUserId = userId
    state.purchases = purchases
    state.isAuthenticated = true
  },

  readFailed(state) {
    state.email = null
    state.nickname = null
    state.urlAlias = null
    state.userId = null
    state.avatar = null
    state.sessionUserId = null
    state.purchases = null
    state.isAuthenticated = false
  },

  sessionRead(state, { userId }) {
    state.sessionUserId = userId
    state.isAuthenticated = true
  },

  sessionReadFailed(state) {
    state.sessionUserId = null
    state.isAuthenticated = false
  },

  authenticated(state, { email, nickname, urlAlias, userId, avatar }) {
    state.email = email
    state.nickname = nickname
    state.urlAlias = urlAlias
    state.userId = userId
    state.avatar = avatar
    state.sessionUserId = userId
    state.isAuthenticated = true
  },

  authenticationFailed(state) {
    state.email = null
    state.nickname = null
    state.urlAlias = null
    state.userId = null
    state.avatar = null
    state.sessionUserId = null
    state.isAuthenticated = false
  }
}

const actions = {
  async read({ commit }) {
    /**
     * read user from session
     */
    try {
      const response = await apiPrivate.get('/user?addField[purchases]=true')
      const userId = dottie.get(response, 'data.user.id', null)
      const email = dottie.get(response, 'data.user.email', null)
      const nickname = dottie.get(response, 'data.user.nickname', null)
      const urlAlias = dottie.get(response, 'data.user.urlAlias', null)
      const purchases = dottie.get(response, 'data.user.purchases', null)
      const avatarData = dottie.get(
        response,
        'data.user.profile.imgs.avatar',
        null
      )

      let avatar = null

      if (userId && avatarData && avatarData.name) {
        avatar = `/services/media/image/${userId}/${avatarData.name}/64/0/image.jpeg`
      }

      commit('sessionRead', { userId })
      commit('read', { email, nickname, urlAlias, userId, avatar, purchases })
    } catch (e) {
      commit('sessionReadFailed')
      commit('readFailed')
    }
  },

  async uniqueEmail(_, email) {
    try {
      const { data } = await apiPrivate.post(`/validate/email`, { email })
      return data.valid
    } catch (e) {
      console.error(e)
    }
  },

  async uniqueNickname(_, nickname) {
    try {
      const { data } = await apiPrivate.post(`/validate/nickname`, { nickname })
      return data.valid
    } catch (e) {
      console.error(e)
    }
  },

  async registerUser(_, { email, password, nickname }) {
    try {
      const { data } = await apiPrivate.post(`/register`, {
        email,
        password,
        nickname
      })
      return data.ok
    } catch (e) {
      console.error(e)
    }
  },

  async loginUser({ commit }, { email, password }) {
    try {
      const response = await apiPrivate.post(`/authenticate`, {
        email,
        password
      })
      const userEmail = dottie.get(response, 'data.user.email', null)
      const nickname = dottie.get(response, 'data.user.nickname', null)
      const urlAlias = dottie.get(response, 'data.user.urlAlias', null)
      const userId = dottie.get(response, 'data.user.id', null)

      const avatarData = dottie.get(
        response,
        'data.user.profile.imgs.avatar',
        null
      )

      let avatar = null

      if (userId && avatarData && avatarData.name) {
        avatar = `/services/media/image/${userId}/${avatarData.name}/64/0/image.jpeg`
      }

      commit('authenticated', {
        email: userEmail,
        nickname,
        urlAlias,
        userId,
        avatar
      })
      return response.data
    } catch (e) {
      console.error(e)
      commit('authenticationFailed')
    }
  },

  gotoLogin(_, { locale }) {
    const path = window.location.pathname
    window.location.href =
      locale === 'en'
        ? `/portal/login?redirect=${path}`
        : `/portal/einloggen?redirect=${path}`
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
